import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Auto-scroll to the top of the page whenever the route changes.
 *
 * Fixes the classic React Router UX bug where clicking a link when the
 * user is scrolled halfway down a long page (e.g. from the SUX1-vs-ChatGPT
 * table on /about to /etudiants) lands them mid-page instead of at the
 * hero.
 *
 * Only reacts to pathname changes — hash navigation (#anchor) still works
 * as expected. Uses "auto" behaviour so it doesn't feel like a jarring
 * animated scroll on route transitions.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
